import { useEffect } from "react";
import { Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import stripeLogo from "../assets/stripe-logo.svg";
import { LinkGen } from "../LinkGen";

export const PagePaymentSimulation = () => {
	const navigate = useNavigate();

	useEffect(() => {
		const timer = setTimeout(() => {
			navigate(LinkGen.Settings.Billing());
		}, 5000);

		return () => clearTimeout(timer);
	}, [navigate]);

	return (
		<div
			style={{
				display: "flex",
				flexDirection: "column",
				alignItems: "center",
				justifyContent: "center",
				height: "100vh",
				width: "100%",
				padding: "20px",
			}}
		>
			<img
				src={stripeLogo}
				alt="Stripe Logo"
				style={{ width: "120px", height: "60px" }}
			/>
			<div className="my-3">
				Please wait while we process your fake payment...
			</div>
			<Spinner animation="border" className="mt-3">
				<span className="visually-hidden">Loading...</span>
			</Spinner>
		</div>
	);
};
